<!-- B01 机构入驻（独立布局，未登录可访问） -->
<template>
  <div class="o2o-apply-page">
    <div class="page-header">
      <div class="header-left">
        <Icon icon="ep:office-building" :size="24" />
        <span class="title">机构入驻申请</span>
      </div>
      <el-button link type="primary" @click="goLogin">已有账号？去登录</el-button>
    </div>

    <div class="page-body">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="提交申请" name="apply">
          <el-card shadow="never">
            <el-alert
              v-if="resubmitMode"
              :title="`上次驳回原因：${rejectRemark || '无'}`"
              type="warning"
              :closable="false"
              show-icon
              class="mb-16px"
            />
            <el-form
              ref="formRef"
              :model="formData"
              :rules="formRules"
              label-width="120px"
              class="apply-form"
            >
              <div class="section-title">机构信息</div>
              <el-form-item label="机构名称" prop="institutionName">
                <el-input v-model="formData.institutionName" placeholder="请输入机构全称" maxlength="100" />
              </el-form-item>
              <el-form-item label="信用代码" prop="licenseNo">
                <el-input v-model="formData.licenseNo" placeholder="统一社会信用代码" maxlength="32" />
              </el-form-item>
              <el-form-item label="营业执照" prop="licenseUrl">
                <UploadImg v-model="formData.licenseUrl" directory="o2o/institution/license" />
              </el-form-item>
              <el-form-item label="法人姓名" prop="legalPerson">
                <el-input v-model="formData.legalPerson" placeholder="法人姓名" maxlength="32" />
              </el-form-item>
              <el-form-item label="身份证正面">
                <UploadImg v-model="formData.idCardFront" directory="o2o/institution/idcard" />
              </el-form-item>
              <el-form-item label="身份证反面">
                <UploadImg v-model="formData.idCardBack" directory="o2o/institution/idcard" />
              </el-form-item>

              <div class="section-title">联系信息</div>
              <el-form-item label="联系手机" prop="contactPhone">
                <el-input v-model="formData.contactPhone" placeholder="11 位手机号，将作为登录账号" maxlength="11" />
              </el-form-item>
              <el-form-item label="联系邮箱" prop="contactEmail">
                <el-input v-model="formData.contactEmail" placeholder="选填" maxlength="64" />
              </el-form-item>
              <el-form-item label="省市区" prop="areaPath">
                <el-cascader
                  v-model="formData.areaPath"
                  class="!w-full"
                  :options="areaTree"
                  :props="storeAreaCascaderProps"
                  clearable
                  filterable
                  placeholder="请选择省 / 市 / 区（区可选）"
                  @change="onAreaPathChange"
                />
              </el-form-item>
              <el-form-item label="详细地址" prop="address">
                <el-input
                  v-model="formData.address"
                  placeholder="街道、门牌号等"
                  maxlength="200"
                  show-word-limit
                />
              </el-form-item>

              <div class="section-title">服务品类</div>
              <el-form-item label="服务品类" prop="serviceCategoryIds">
                <el-tree-select
                  v-model="categoryCheckedKeys"
                  :data="categoryTreeOptions"
                  :props="categoryTreeProps"
                  node-key="value"
                  multiple
                  show-checkbox
                  filterable
                  default-expand-all
                  placeholder="请选择服务品类（父级勾选=全选该分类下所有服务）"
                  class="w-full category-tree-select"
                  @change="handleCategoryChange"
                />
                <div v-if="selectedCategoryLabels.length" class="selected-category-box">
                  <span class="selected-label">已选 {{ selectedCategoryLabels.length }} 项：</span>
                  <el-tag
                    v-for="item in selectedCategoryLabels"
                    :key="item.id"
                    closable
                    size="small"
                    class="selected-tag"
                    @close="removeCategory(item.id)"
                  >
                    {{ item.label }}
                  </el-tag>
                </div>
                <div class="form-tip">勾选父级（如「家电维修」）将自动选中其下全部末级品类；也可单独勾选子项</div>
              </el-form-item>

              <div class="section-title">管理员账号</div>
              <el-form-item label="登录密码" prop="loginPassword">
                <el-input
                  v-model="formData.loginPassword"
                  type="password"
                  show-password
                  placeholder="6-20 位，审通后用于商家中心登录"
                  maxlength="20"
                />
              </el-form-item>
              <el-form-item label="确认密码" prop="confirmPassword">
                <el-input
                  v-model="formData.confirmPassword"
                  type="password"
                  show-password
                  placeholder="再次输入密码"
                  maxlength="20"
                />
              </el-form-item>

              <el-form-item>
                <el-button type="primary" :loading="submitLoading" @click="handleSubmit">
                  {{ resubmitMode ? '重新提交' : '提交申请' }}
                </el-button>
                <el-button @click="goLogin">返回登录</el-button>
              </el-form-item>
            </el-form>
          </el-card>
        </el-tab-pane>

        <el-tab-pane label="查询进度" name="status">
          <el-card shadow="never">
            <el-alert
              title="申请单号在「提交申请」成功后会弹出提示，格式如 O2O-INST-20260709-0001；请妥善保存，配合联系手机后 4 位查询审核进度。"
              type="info"
              :closable="false"
              show-icon
              class="mb-16px"
            />
            <el-form :model="statusQuery" label-width="120px" class="status-form">
              <el-form-item label="申请单号">
                <el-input v-model="statusQuery.applyNo" placeholder="例如 O2O-INST-20260709-0001" />
              </el-form-item>
              <el-form-item label="手机后四位">
                <el-input v-model="statusQuery.phoneSuffix" maxlength="4" placeholder="联系手机后 4 位" />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :loading="statusLoading" @click="handleQueryStatus">查询</el-button>
              </el-form-item>
            </el-form>

            <el-result
              v-if="statusResult"
              :icon="statusIcon"
              :title="statusTitle"
              :sub-title="statusSubTitle"
            >
              <template #extra>
                <el-button v-if="statusResult.auditStatus === 1" type="primary" @click="goLogin">去登录</el-button>
                <el-button
                  v-else-if="statusResult.auditStatus === 2"
                  type="primary"
                  @click="switchToResubmit"
                >
                  修改后重提
                </el-button>
              </template>
            </el-result>
          </el-card>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { FormInstance, FormRules } from 'element-plus'
import { useRoute, useRouter } from 'vue-router'
import { UploadImg } from '@/components/UploadFile'
import { getAreaTree } from '@/api/merchant/system/area'
import {
  createO2oInstitutionApply,
  getO2oInstitutionApplyCategoryTree,
  getO2oInstitutionApplyStatus,
  type O2oInstitutionApplyCategoryVO,
  type O2oInstitutionApplyStatusVO
} from '@/api/merchant/o2o/institution'
import {
  resolveStoreAreaByPath,
  storeAreaCascaderProps
} from '@/views/o2o/utils/storeArea'

defineOptions({ name: 'MerchantO2oInstitutionApply' })

const message = useMessage()
const router = useRouter()
const route = useRoute()

const activeTab = ref('apply')
const submitLoading = ref(false)
const statusLoading = ref(false)
const resubmitMode = ref(false)
const rejectRemark = ref('')
const categoryTree = ref<O2oInstitutionApplyCategoryVO[]>([])
const statusResult = ref<O2oInstitutionApplyStatusVO | null>(null)
const areaTree = ref<any[]>([])

type CategoryTreeOption = {
  value: number
  label: string
  isLeaf?: boolean
  children?: CategoryTreeOption[]
}

const categoryTreeProps = {
  label: 'label',
  value: 'value',
  children: 'children'
}

function buildCategoryTreeOptions(nodes: O2oInstitutionApplyCategoryVO[]): CategoryTreeOption[] {
  return (nodes || [])
    .filter((node) => node.id != null)
    .map((node) => {
      const children = node.children?.length ? buildCategoryTreeOptions(node.children) : undefined
      const isLeaf = node.leaf === true || !children?.length
      return {
        value: node.id as number,
        label: node.name,
        isLeaf,
        children
      }
    })
}

const categoryTreeOptions = computed(() => buildCategoryTreeOptions(categoryTree.value))
const categoryCheckedKeys = ref<number[]>([])

function collectDescendantLeaves(node: CategoryTreeOption): number[] {
  if (!node.children?.length) {
    return node.value != null ? [node.value] : []
  }
  return node.children.flatMap(collectDescendantLeaves).filter((id) => id != null)
}

function findNodeById(nodes: CategoryTreeOption[], id: number): CategoryTreeOption | undefined {
  for (const node of nodes) {
    if (node.value === id) {
      return node
    }
    if (node.children?.length) {
      const found = findNodeById(node.children, id)
      if (found) {
        return found
      }
    }
  }
  return undefined
}

function normalizeToLeafIds(checkedIds: number[]): number[] {
  const result = new Set<number>()
  checkedIds.filter((id) => id != null).forEach((id) => {
    const node = findNodeById(categoryTreeOptions.value, id)
    if (!node) {
      return
    }
    collectDescendantLeaves(node).forEach((leafId) => result.add(leafId))
  })
  return Array.from(result)
}

function expandCheckedKeys(leafIds: number[]): number[] {
  const leafSet = new Set(leafIds)
  const checked = new Set<number>(leafIds)
  const walk = (nodes: CategoryTreeOption[]) => {
    nodes.forEach((node) => {
      if (node.children?.length) {
        walk(node.children)
        const leaves = collectDescendantLeaves(node)
        if (leaves.length > 0 && leaves.every((id) => leafSet.has(id))) {
          checked.add(node.value)
        }
      }
    })
  }
  walk(categoryTreeOptions.value)
  return Array.from(checked)
}

const formRef = ref<FormInstance>()
const formData = reactive({
  institutionName: '',
  licenseNo: '',
  licenseUrl: '',
  legalPerson: '',
  idCardFront: '',
  idCardBack: '',
  contactPhone: '',
  contactEmail: '',
  province: '',
  city: '',
  district: '',
  address: '',
  areaPath: undefined as number[] | undefined,
  serviceCategoryIds: [] as number[],
  loginPassword: '',
  confirmPassword: ''
})

const ensureAreaTree = async () => {
  if (areaTree.value.length) return
  areaTree.value = (await getAreaTree()) || []
}

const applyAreaNames = (path?: number[]) => {
  const names = resolveStoreAreaByPath(areaTree.value, path)
  formData.province = names.province
  formData.city = names.city
  formData.district = names.district
}

const onAreaPathChange = (path?: number[]) => {
  applyAreaNames(path)
}

const validateAreaPath = (_rule: unknown, value: number[] | undefined, callback: (e?: Error) => void) => {
  if (!value?.length || value.length < 2) {
    callback(new Error('请选择省市区（至少选到市）'))
    return
  }
  callback()
}

const leafCategoryIds = computed(() => {
  const ids = new Set<number>()
  const walk = (nodes?: CategoryTreeOption[]) => {
    nodes?.forEach((node) => {
      if (node.isLeaf) {
        ids.add(node.value)
      }
      walk(node.children)
    })
  }
  walk(categoryTreeOptions.value)
  return ids
})

const selectedCategoryLabels = computed(() =>
  formData.serviceCategoryIds
    .filter((id) => leafCategoryIds.value.has(id))
    .map((id) => ({
      id,
      label: findCategoryLabel(categoryTreeOptions.value, id) || `品类#${id}`
    }))
)

function findCategoryLabel(nodes: CategoryTreeOption[], id: number): string | undefined {
  for (const node of nodes) {
    if (node.value === id) {
      return node.label
    }
    if (node.children?.length) {
      const label = findCategoryLabel(node.children, id)
      if (label) {
        return label
      }
    }
  }
  return undefined
}

function handleCategoryChange(value: number[] | number) {
  const keys = Array.isArray(value) ? value : [value]
  categoryCheckedKeys.value = keys
  formData.serviceCategoryIds = normalizeToLeafIds(keys)
}

function removeCategory(id: number) {
  const nextLeafIds = formData.serviceCategoryIds.filter((item) => item !== id)
  formData.serviceCategoryIds = nextLeafIds
  categoryCheckedKeys.value = expandCheckedKeys(nextLeafIds)
}

const statusQuery = reactive({
  applyNo: '',
  phoneSuffix: ''
})

const validateConfirmPassword = (_rule: unknown, value: string, callback: (err?: Error) => void) => {
  if (value !== formData.loginPassword) {
    callback(new Error('两次输入的密码不一致'))
  } else {
    callback()
  }
}

const formRules: FormRules = {
  institutionName: [{ required: true, message: '请输入机构名称', trigger: 'blur' }],
  licenseNo: [{ required: true, message: '请输入统一社会信用代码', trigger: 'blur' }],
  legalPerson: [{ required: true, message: '请输入法人姓名', trigger: 'blur' }],
  contactPhone: [
    { required: true, message: '请输入联系手机', trigger: 'blur' },
    { pattern: /^1\d{10}$/, message: '手机号格式不正确', trigger: 'blur' }
  ],
  contactEmail: [{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }],
  areaPath: [{ required: true, validator: validateAreaPath, trigger: 'change' }],
  address: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
  serviceCategoryIds: [{ required: true, type: 'array', min: 1, message: '请至少选择一个服务品类', trigger: 'change' }],
  loginPassword: [
    { required: true, message: '请输入登录密码', trigger: 'blur' },
    { min: 6, max: 20, message: '密码长度为 6-20 位', trigger: 'blur' }
  ],
  confirmPassword: [
    { required: true, message: '请确认密码', trigger: 'blur' },
    { validator: validateConfirmPassword, trigger: 'blur' }
  ]
}

const statusIcon = computed(() => {
  if (!statusResult.value) return 'info'
  const map: Record<number, 'info' | 'success' | 'warning' | 'error'> = {
    0: 'info',
    1: 'success',
    2: 'error'
  }
  return map[statusResult.value.auditStatus] || 'info'
})

const statusTitle = computed(() => {
  if (!statusResult.value) return ''
  const map: Record<number, string> = { 0: '审核中', 1: '审核通过', 2: '已驳回' }
  return map[statusResult.value.auditStatus] || '未知状态'
})

const statusSubTitle = computed(() => {
  if (!statusResult.value) return ''
  const parts = [`机构：${statusResult.value.institutionName}`, `单号：${statusResult.value.applyNo}`]
  if (statusResult.value.auditRemark) {
    parts.push(`备注：${statusResult.value.auditRemark}`)
  }
  return parts.join('；')
})

async function loadCategoryTree() {
  categoryTree.value = await getO2oInstitutionApplyCategoryTree()
}

async function handleSubmit() {
  applyAreaNames(formData.areaPath)
  await formRef.value?.validate()
  submitLoading.value = true
  try {
    const result = await createO2oInstitutionApply({
      institutionName: formData.institutionName,
      licenseNo: formData.licenseNo,
      licenseUrl: formData.licenseUrl || undefined,
      legalPerson: formData.legalPerson,
      idCardFront: formData.idCardFront || undefined,
      idCardBack: formData.idCardBack || undefined,
      contactPhone: formData.contactPhone,
      contactEmail: formData.contactEmail || undefined,
      province: formData.province || undefined,
      city: formData.city || undefined,
      district: formData.district || undefined,
      address: formData.address,
      serviceCategoryIds: formData.serviceCategoryIds,
      loginPassword: formData.loginPassword
    })
    message.success(`提交成功，申请单号：${result.applyNo}`)
    localStorage.setItem('o2o_last_apply_no', result.applyNo)
    localStorage.setItem('o2o_last_phone_suffix', formData.contactPhone.slice(-4))
    statusQuery.applyNo = result.applyNo
    statusQuery.phoneSuffix = formData.contactPhone.slice(-4)
    activeTab.value = 'status'
    await handleQueryStatus()
  } finally {
    submitLoading.value = false
  }
}

async function handleQueryStatus() {
  if (!statusQuery.applyNo || statusQuery.phoneSuffix.length !== 4) {
    message.warning('请填写申请单号和手机后四位')
    return
  }
  statusLoading.value = true
  try {
    statusResult.value = await getO2oInstitutionApplyStatus({
      applyNo: statusQuery.applyNo,
      phoneSuffix: statusQuery.phoneSuffix
    })
    if (statusResult.value.auditStatus === 2) {
      rejectRemark.value = statusResult.value.auditRemark || ''
    }
  } finally {
    statusLoading.value = false
  }
}

function switchToResubmit() {
  if (statusResult.value) {
    formData.institutionName = statusResult.value.institutionName
    rejectRemark.value = statusResult.value.auditRemark || ''
  }
  resubmitMode.value = true
  activeTab.value = 'apply'
  message.info('请使用原联系手机作为登录账号，修改资料后重新提交')
}

function goLogin() {
  router.push('/store/login')
}

onMounted(async () => {
  await Promise.all([loadCategoryTree(), ensureAreaTree()])
  if (route.query.applyNo) {
    statusQuery.applyNo = String(route.query.applyNo)
    activeTab.value = 'status'
  } else {
    const savedApplyNo = localStorage.getItem('o2o_last_apply_no')
    const savedPhoneSuffix = localStorage.getItem('o2o_last_phone_suffix')
    if (savedApplyNo) {
      statusQuery.applyNo = savedApplyNo
    }
    if (savedPhoneSuffix) {
      statusQuery.phoneSuffix = savedPhoneSuffix
    }
  }
  if (route.query.tab === 'status') {
    activeTab.value = 'status'
  }
})
</script>

<style lang="scss" scoped>
.o2o-apply-page {
  /* 全局 body overflow:hidden，本页自建滚动容器 */
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  background: var(--app-content-bg-color, #f5f7fa);
}

.page-header {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background: #fff;
  border-bottom: 1px solid #ebeef5;

  .header-left {
    display: flex;
    align-items: center;
    gap: 8px;

    .title {
      font-size: 18px;
      font-weight: 600;
      color: #303133;
    }
  }
}

.page-body {
  max-width: 960px;
  margin: 24px auto 48px;
  padding: 0 16px 24px;
}

.section-title {
  margin: 8px 0 16px;
  padding-left: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  border-left: 3px solid var(--el-color-primary);
}

.apply-form,
.status-form {
  max-width: 720px;
}

.category-tree-select {
  width: 100%;
}

.selected-category-box {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin-top: 10px;
  padding: 10px 12px;
  background: #f5f7fa;
  border-radius: 6px;
}

.selected-label {
  font-size: 13px;
  color: #606266;
}

.selected-tag {
  margin: 0;
}

.form-tip {
  width: 100%;
  margin-top: 8px;
  font-size: 12px;
  line-height: 1.5;
  color: #909399;
}
</style>
